import React from 'react';
import { getTemplate } from 'TRANSLATION';
const Content = getTemplate('hint/professionalStatusCertification');

export default function PEPHint() {
  return <Content />;
}
